var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'iframe-mode': _vm.isInIframe }},[(_vm.windowResize.width > 650)?_c('PendingApprovalDesktop'):(_vm.windowResize.width  > 640)?_c('PendingApprovalMobile'):_c('RotateScreen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }